import axios from 'axios';

import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
var tokenid = localStorage.getItem("tokenid");
const wingId = parseInt(localStorage.getItem('wingId')) || 0;



export const getPtmTopperListSvc = (ptmId, sectionId, callback) => {
    // console.log("getPtmTopperListSvc called, ptmId", ptmId, ", sectiond", sectionId);
    const formData = new FormData();
    formData.append("ptmId", ptmId)
    formData.append("sectionId", sectionId)
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/ptm_plan/topper/list',
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getPtmTopperListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstPtmTopper = response.data.lstPtmTopper;
            obj.basePathPtmToppers = response.data.basePathPtmToppers;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export const getGalleryListSvc = (ptmId, callback) => {
    // console.log("getGalleryListSvc called, ptmId", ptmId);
    const formData = new FormData();
    formData.append("ptmId", ptmId);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/ptm_plan/gallery/list',
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getGalleryListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstPtmGallery = response.data.lstPtmGallery;
            obj.basePathPtmGalery = response.data.basePathPtmGalery;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}

export const removePtmTopperSvc = (ptmId, sectionId, rank, callback) => {
    // console.log("removePtmTopperSvc called, ptmId", ptmId, ", sectiond", sectionId);
    const formData = new FormData();
    formData.append("ptmId", ptmId);
    formData.append("topperRank", rank);
    formData.append("sectionId", sectionId)
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/ptm_plan/topper/remove',
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in removePtmTopperSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}

export const removeGalleryImageSvc = (ptmId, imgNo, callback) => {
    // console.log("removeGalleryImageSvc called, ptmId", ptmId, ", imgNo", imgNo);
    const formData = new FormData();
    formData.append("ptmId", ptmId);
    formData.append("imgNo", imgNo)
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/ptm_plan/gallery/remove',
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in removeGalleryImageSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}

export const getExamListSvc = (callback) => {
    // console.log("getExamListSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/performance/mst/exam/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getExamListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstExam = response.data.lstExam;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}

export function getClassListSvc(callback1) {
    // console.log("getClassListSvc service called");
    axios({
        url: httpURL + '/sms/cls/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getClassListSvc', response);
        callback1(response.data);
    }).catch((error) => {
        callback1(error);
    });
}

export function getSectionListSvc(callback2, pClassId) {
    // console.log("getSectionListSvc called, pClassId passed", pClassId);
    axios({
        url: httpURL + "/sms/cls/sec/list",
        method: "POST",
        params: { screenId: 8, classId: pClassId },
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getSectionListSvc', response);
        // console.log('data.SvcStatus=' + response.data.SvcStatus);
        callback2(response.data);
    }).catch((error) => {
        callback2(error);
    });
}


export const getStudentListSvc = (classId, sectionId, callback) => {
    // console.log("getStudentListSvc called, classId", classId, ", sectiond", sectionId);
    const formData = new FormData();
    formData.append("classId", classId)
    formData.append("sectionId", sectionId)
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/cls/stu/list',
        // url: httpURL + '/sms/ptm_plan/topper/student_list',
        method: "POST",
        data: formData,
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getStudentListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstClassStudents = response.data.lstClassStudents;
            // obj.lstClassStudents = response.data.lstStudent;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export function saveStudentPhotoSvc(ptmTopper, imgFile, callback) {
    // console.log("saveStudentPhotoSvc called, ptmTopper", ptmTopper);
    var formData = new FormData();
    formData.append("ptmTopper", JSON.stringify(ptmTopper));
    formData.append("imgFile", imgFile);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + "/sms/ptm_plan/topper/save",
        method: "POST",
        data: formData,

        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log("response in saveStudentPhtoSvc", response);
        obj.status = response.data.SvcStatus || "Failure";
        obj.message = response.data.SvcMsg || "Unknown error";
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error || "Request failed";
        callback(obj);
    });
}


export function saveGalleryPhotoSvc(ptmGallery, imgFile, callback) {
    // console.log("saveGalleryPhotoSvc called, ptmGallery", ptmGallery);
    var formData = new FormData();
    formData.append("ptmGallery", JSON.stringify(ptmGallery));
    formData.append("imgFile", imgFile);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + "/sms/ptm_plan/gallery/save",
        method: "POST",
        data: formData,

        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log("response in saveGalleryPhotoSvc", response);
        obj.status = response.data.SvcStatus || "Failure";
        obj.message = response.data.SvcMsg || "Unknown error";
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error || "Request failed";
        callback(obj);
    });
}